import {isEmpty, nth} from 'ramda';

export const pickRandomValueFromArr = <T>(arr: T[]) => {
  if (isEmpty(arr)) {
    return undefined;
  }
  const randomIndex = Math.floor(Math.random() * arr.length);
  return nth(randomIndex, arr);
};
